module.exports = __webpack_public_path__ + "img/title-bg.7769a4a7.png";